import { RetailContractSection } from './RetailContractSection';
import { DmaContractSection } from './DmaContractSection';
import {
  NetworkTariffSection, type TariffOption, type CatalogBucket,
} from './NetworkTariffSection';
import { EnvironmentalConfigSection } from './EnvironmentalConfigSection';

type Props = {
  siteId: string;
  siteState?: string;
  /** `bv_extn.network_distributor`, for the network card's mismatch warning. */
  siteDistributor?: string | null;
  /** The catalog codes the network card's picker offers. Passed down rather than
   *  loaded again: the page already holds the full paged catalog. */
  tariffOptions?: TariffOption[];
  /** Opens the page's catalog-code dialog from inside the network card. */
  onDefineCatalogCode?: () => void;
  /** Opens that dialog on an existing catalog code. */
  onEditCatalogCode?: (tariffCode: string) => void;
  /** True while the page is still paging the tariff catalog in. */
  catalogLoading?: boolean;
  /** Every catalog bucket row, for the network card's published-prices block. */
  catalogRows?: CatalogBucket[];
};

export function ContractsTabs({
  siteId, siteState, siteDistributor, tariffOptions,
  onDefineCatalogCode, onEditCatalogCode, catalogLoading, catalogRows,
}: Props) {
  return (
    <div className="p-4 space-y-6">
      <RetailContractSection siteId={siteId} />
      <div className="border-t border-gray-100" />
      <DmaContractSection siteId={siteId} />
      <div className="border-t border-gray-100" />
      {/* Job 35: was DistributionConfigSection, which wrapped two more tables
          built by SiteDetailPage. The network card owns its own state now — it
          reads and writes bv_contract like every other card here, so nothing has
          to be threaded in from the page except the catalog to pick from. */}
      <NetworkTariffSection
        siteId={siteId}
        siteDistributor={siteDistributor}
        tariffOptions={tariffOptions}
        onDefineCatalogCode={onDefineCatalogCode}
        onEditCatalogCode={onEditCatalogCode}
        catalogLoading={catalogLoading}
        catalogRows={catalogRows}
      />
      <div className="border-t border-gray-100" />
      <EnvironmentalConfigSection siteId={siteId} siteState={siteState} />
    </div>
  );
}
